import { useCallback, useEffect, useMemo, useState } from "react";
import { useAuthStore } from "../Contexts/AuthContext";
import { getPixTransactionalLimits } from "../Services/pixLimitsApi";
import {
  PIX_LIMIT_CATEGORY_META,
  PIX_LIMIT_PERIODS,
  resolvePixLimitMeta,
} from "../Pages/Private/Pix/PixLimits/constants";

const attachMeta = (item) => {
  const meta = resolvePixLimitMeta(item);
  return {
    ...item,
    id: meta.code || item.id,
    label: meta.label,
    description: meta.description || item.description || "",
    icon: meta.icon || PIX_LIMIT_CATEGORY_META.enviado.icon,
    comingSoon: meta.comingSoon || item.comingSoon,
  };
};

export const usePixLimits = () => {
  const isAutenticated = useAuthStore((state) => state.isAutenticated);
  const token = useAuthStore((state) => state.token);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await getPixTransactionalLimits();
      setItems((result.items || []).map(attachMeta));
    } catch (err) {
      setItems([]);
      setError(
        err?.response?.data?.detail ||
          err?.response?.data?.title ||
          err?.message ||
          "Não foi possível carregar os limites.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!isAutenticated || !token?.trim()) {
      setItems([]);
      setError(null);
      setLoading(false);
      return;
    }
    load();
  }, [load, token, isAutenticated]);

  const byPeriod = useMemo(() => {
    const groups = {
      diurno: [],
      noturno: [],
    };

    for (const item of items) {
      const key = item.period === "noturno" ? "noturno" : "diurno";
      groups[key].push(item);
    }

    return groups;
  }, [items]);

  const periodMetaFor = useCallback(
    (periodId) => {
      const base = PIX_LIMIT_PERIODS[periodId] || PIX_LIMIT_PERIODS.diurno;
      const sample = byPeriod[periodId]?.[0];
      if (sample?.periodHours) {
        return {
          ...base,
          hours: sample.periodHours,
          description: `Limites válidos no período ${base.label.toLowerCase()}, ${sample.periodHours}.`,
        };
      }
      return base;
    },
    [byPeriod],
  );

  return {
    items,
    byPeriod,
    periodMetaFor,
    loading,
    error,
    reload: load,
  };
};
